{
  "gitSha": "f6d7817b7334a24d8a0af7f5bfe6ac8eee070e36",
  "gitShaShort": "f6d781",
  "packageVersion": "1.162.1",
  "sentryRelease": "f6d7817b7334a24d8a0af7f5bfe6ac8eee070e36",
  "buildStartedAt": "2025-06-04T12:43:50+02:00"
}